import React from 'react';
import { motion } from 'framer-motion';
import { YellowButton } from '../ui/YellowButton';
import { Section } from '../ui/Section';
export function Hero({
  onScrollToCheckout
}: {
  onScrollToCheckout: () => void;
}) {
  return <Section className="pt-32 pb-20 md:pt-40 md:pb-32 relative overflow-hidden" data-id="element-135">
      {/* Background Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[500px] bg-yellow-500/10 blur-[120px] rounded-full pointer-events-none" data-id="element-136" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-137">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="inline-block mb-6" data-id="element-138">
          <span className="bg-yellow-500/10 text-yellow-500 border border-yellow-500/20 px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-widest" data-id="element-139">
            Nadie te preparó para esto...
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="text-5xl md:text-7xl font-extrabold text-white mb-6 leading-tight tracking-tight" data-id="element-140">
          DEJÁ DE SER <br data-id="element-141" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600" data-id="element-142">
            SUBESTIMADO HOY
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="text-xl text-zinc-400 max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-143">
          El sistema de inteligencia social que usan los líderes para detectar
          engaños, dominar conversaciones y ganar respeto instantáneo.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="flex flex-col items-center gap-4" data-id="element-144">
          <YellowButton onClick={onScrollToCheckout} size="lg" icon="arrow-down" className="w-full md:w-auto min-w-[300px] shadow-[0_0_40px_rgba(234,179,8,0.3)]" data-id="element-145">
            QUIERO EL SISTEMA COMPLETO
          </YellowButton>
          <p className="text-zinc-500 text-xs uppercase tracking-wide" data-id="element-146">
            🔒 Garantía de 7 días • Acceso Inmediato
          </p>
        </motion.div>

        {/* Product Mockup - Real Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="mt-16 relative mx-auto max-w-sm group" data-id="element-147">
          <div className="absolute inset-0 bg-yellow-500/30 blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-700 rounded-full" data-id="element-148" />
          <img src="https://cdn.magicpatterns.com/uploads/jq4oCouCmrcu5LgrGg5Vut/ChatGPT_Image_23_feb_2026,_13_39_58.png" alt="Inteligencia Social Estratégica - Manual Completo" className="relative z-10 w-full h-auto object-contain drop-shadow-[0_20px_60px_rgba(234,179,8,0.25)] group-hover:drop-shadow-[0_20px_80px_rgba(234,179,8,0.4)] transition-all duration-700" data-id="element-149" />
        </motion.div>
      </div>
    </Section>;
}